import type { Persona } from "./persona"

export const TOKEN_TIMEFRAME_PREFERENCE_COOKIE_NAME =
  "token-chart-timeframe-preference"

export const DEFAULT_TOKEN_TIMEFRAME_VALUE = "ONE_DAY"

export const getDefaultTokenTimeframe = (_persona: Persona) => {
  return DEFAULT_TOKEN_TIMEFRAME_VALUE
}
